import React from 'react';

import { RouteComponentProps, useParams } from 'react-router';
import { AppPage } from '../AppContent';
import { MapLeaflet } from '../components/map/MapLeaflet';

interface MapsPageProps extends RouteComponentProps {}

export const MapPageLeaflet: React.FC<MapsPageProps> = (
  props: MapsPageProps
) => {
  const { tagId }: any = useParams();

  return (
    <AppPage>
      <div className="map-leaflet relative w-full h-full">
        <MapLeaflet tagId={tagId} />
      </div>
    </AppPage>
  );
};
